import { inject, Inject, Injectable, PendingTasks, PLATFORM_ID } from '@angular/core'
import { defer, Observable } from 'rxjs'
import { finalize } from 'rxjs/operators'
import {
  HeaderAndFooterResponseInterface,
  WagtailCategoryResponseInterface,
  WagtailPageResponseInterface
} from "@gea-waldviertler-website/gea-models";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { isPlatformServer } from "@angular/common";
import { EnvService } from "@gea-waldviertler-website/shop-lib";

export interface SimpleKeyValueInterface {
  [key: string]: string | number
}

@Injectable()
export class HttpWagtailService {
  private envService = inject(EnvService)
  private pendingTasks = inject(PendingTasks)

  constructor(
    private http: HttpClient, backend: HttpBackend,
    @Inject(PLATFORM_ID) private platformId: typeof PLATFORM_ID,
) {
    this.http = new HttpClient(backend)
  }

  getPage(pageId: number, params?: SimpleKeyValueInterface) : Observable<WagtailPageResponseInterface> {

    let url: URL = new URL(this.getCmsApiBaseUrl() + `/pages/${pageId}/`)
    if (params) {
      for (const [key, value] of Object.entries(params)) {
        url.searchParams.append(key, String(value))
      }
    }

    return this.track(this.http.get<WagtailPageResponseInterface>(url.toString()))
  }

  getCategoryPages(slug: string): Observable<WagtailCategoryResponseInterface> {
    let url: URL = new URL(this.getCmsApiBaseUrl() + `/pages/?shop_cat=${slug}`)
    return this.track(this.http.get<WagtailCategoryResponseInterface>(url.toString()))
  }

  getHeaderAndFooter(): Observable<HeaderAndFooterResponseInterface> {
    let url: URL = new URL(this.getCmsCustomApiUrl())
    return this.track(this.http.get<HeaderAndFooterResponseInterface>(url.toString()))
  }

  /**
   * Dieser HttpClient umgeht die Interceptor-Kette (bewusst: keine Auth/XSRF/Version-Interceptoren für CMS),
   * damit aber auch das PendingTasks-Tracking von Angular. Für SSR (whenStable) wird es hier nachgeholt.
   */
  private track<T>(obs: Observable<T>): Observable<T> {
    return defer(() => {
      const remove = this.pendingTasks.add()
      return obs.pipe(finalize(remove))
    })
  }

  getCmsApiBaseUrl() {
    if (isPlatformServer(this.platformId)) return this.envService.config.cmsBaseUrl_SSR + '/wagtailapi/v2'
    return this.envService.config.cmsBaseUrl + '/wagtailapi/v2'
  }

  getCmsCustomApiUrl() {
    if (isPlatformServer(this.platformId)) return this.envService.config.cmsBaseUrl_SSR + '/api/'
    return this.envService.config.cmsBaseUrl + '/api/'
  }
}
